import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from './facade.service';
import { MsRegistrationFormState } from '../reducers/ms-registration-form.reducer';
import * as selectors from '../selectors/ms-registration-form.selectors';

@Injectable({
  providedIn: 'root',
})
export class MsRegistrationFormFacadeService extends FacadeService {
  constructor(public override store: Store<MsRegistrationFormState>) {
    super(store);
  }

  // OBSERVABLES

  token$ = this.storeSelect(selectors.getToken);
  msRegistrationForm$ = this.storeSelect(selectors.getMsRegistrationFormState);
  qcCode$ = this.storeSelect(selectors.getQcCode);
  showMessageStatus$ = this.storeSelect(selectors.getShowMessageStatus);
  message$ = this.storeSelect(selectors.getMessage);
  firstName$ = this.storeSelect(selectors.getFirstName);
  email$ = this.storeSelect(selectors.getEmail);
  fName$ = this.storeSelect(selectors.getFName);
  lName$ = this.storeSelect(selectors.getLName);
  cNumber$ = this.storeSelect(selectors.getCNumber);

  // OBSERVABLE'S VALUES

  get token() {
    return this.storeSnapshot(this.token$);
  }

  get msRegistrationForm() {
    return this.storeSnapshot(this.msRegistrationForm$);
  }

  get qcCode() {
    return this.storeSnapshot(this.qcCode$);
  }

  get email() {
    return this.storeSnapshot(this.email$);
  }

  get fName() {
    return this.storeSnapshot(this.fName$);
  }

  get lName() {
    return this.storeSnapshot(this.lName$);
  }

  get cNumber() {
    return this.storeSnapshot(this.cNumber$);
  }
}
